<template>
    <div>
        <div class="modal fade" id="websiteFormModal" tabindex="-1" role="dialog" aria-labelledby="confirmModalLabel"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="confirmModalLabel">Website</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close">

                        </button>
                    </div>
                    <div v-if="website" class="modal-body">
                        <form>
                            <div class="row mb-3">
                                <label for="nameInput" class="col-sm-4 col-form-label">Name</label>
                                <div class="col-sm-8">
                                    <input id="nameInput" type="text" class="form-control" placeholder="website name"
                                           v-model="website.name">
                                </div>
                            </div>

                            <div v-if="isCustomer" class="form-group row">
                                <label for="customDomainInput" class="col-sm-4 col-form-label">Custom domain</label>
                                <div class="col-sm-8">
                                    <input id="customDomainInput" type="text" class="form-control"
                                           placeholder="custom domain"
                                           v-model="website.custom_domain">
                                </div>
                            </div>

                            <div v-else class="form-group row">
                                <label class="col-sm-4 col-form-label">Custom domain</label>
                                <div class="col-sm-8">
                                    <input type="text" class="form-control" placeholder="custom domain" readonly>
                                    <small class="form-text text-success">
                                        <strong><a href="https://www.webase.com/pricing" target="_blank">Upgrade to
                                            publish to a custom domain!</a></strong>
                                    </small>
                                </div>
                            </div>

                            <div v-if="!hasNetlifyIntegration" class="card mb-2">

                                <div class="card-body">
                                    <p class="card-text">WeBase uses Netlify for custom domain hosting. Please connect
                                        to a free Netlify account here:</p>

                                    <div class="border rounded p-2" style="border-color: #2bbbb8 !important;">
                                        <a :href="netlifyUrl">
                                            <netlify></netlify>
                                        </a>
                                    </div>

                                </div>
                            </div>

                            <div v-if="hasDnsZone" class="alert alert-warning" role="alert">
                                Please update your name servers at the registrar of your domain to use these values:
                                <br><br>

                                <div v-for="dns_server in website.metadata.netlifyDns.dns_servers">
                                    <strong>{{dns_server}}</strong><br>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <label for="gtagInput" class="col-sm-4 col-form-label">Google Tag Manager ID</label>
                                <div class="col-sm-8">
                                    <input id="gtagInput" type="text" class="form-control" placeholder="GTM-M3LWMEH"
                                           v-model="website.metadata.tagManagerId">
                                </div>
                            </div>

                            <div v-if="hasNetlifyIntegration" class="form-group row">
                                <label for="netlifySiteOptions" class="col-sm-3 col-form-label">Netlify Site</label>
                                <div class="col-sm-9">
                                    <select id="netlifySiteOptions" class="form-control"
                                            v-model="website.metadata.netlifySiteId">
                                        <option v-for="site in netlifyIntegration.metadata.sites" :value="site.id">
                                            {{site.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="isExistingSite" class="mb-3">
                                <a href="javascript:void(0)" @click="showAdvanced = !showAdvanced">{{advancedLabel}}</a>
                            </div>

                            <div v-if="showAdvanced" class="form-group row">
                                <label for="gaInput" class="col-sm-4 col-form-label">Google Analytics ID</label>
                                <div class="col-sm-8">
                                    <input id="gaInput" type="text" class="form-control" placeholder="UA-132327579-1"
                                           v-model="website.ga_tracking_id">
                                </div>
                            </div>

                            <div v-if="website.id && showAdvanced" class="ms-auto mt-2">
                                <button class="btn btn-sm btn-danger" @click.prevent="onDeleteClick">Delete Site
                                </button>
                            </div>

                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn modal-btn btn-primary" @click="yesHandler">Ok</button>
                        <button type="button" class="btn modal-btn btn-secondary " @click="noHandler">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import SiteService from "../../services/SiteService";
    import Netlify from "../../integrations/Netlify.vue";

    export default {
        name: 'WebsiteFormModal',
        components: {Netlify},
        props: {
            yesEvent: Function
        },
        data() {
            return {
                model: webase.model,
                service: new SiteService(),
                app: webase.model.app,
                errorMessage: null,
                showAdvanced: false,
                website: null,
                currentModal: null,
                modalElement: null,
            }
        },
        computed: {
            isCustomer() {
                return webase.utils.user.isCustomer()
            },
            hasDnsZone() {
                return !!this.website.metadata.netlifyDns && this.website.metadata.netlifySsl === undefined
            },
            advancedLabel() {
                return this.showAdvanced ? 'Hide' : 'Advanced'
            },
            isExistingSite() {
                return !!this.website.id
            },
            hasNetlifyIntegration() {

                if (this.app && webase.managers.app && webase.managers.app.hasIntegration('Netlify')) {
                    return true
                }

                return false
            },
            netlifyIntegration() {
                return webase.managers.app.getIntegration('Netlify')
            },
            netlifyUrl() {
                let url = 'https://app.netlify.com/authorize?client_id=' + this.netlifyClientId + '&response_type=code'
                return url + '&redirect_uri=' + this.netlifyRedirectUri + '&app_id=' + this.model.app.id
            },

            netlifyRedirectUri() {
                if (process.env.NODE_ENV === 'development') {
                    return 'http://localhost:3000/auth/callback/netlify'
                }

                return 'https://www.webase.com/auth/callback/netlify'
            },

            netlifyClientId() {
                if (process.env.NODE_ENV === 'development') {
                    return 'DXXFjrswBWaAm8UsXptl3eLR1e7j-DT68yWW9ccdYA8'
                }

                return '129b258d256c94900cf106c9c2ddc772f8ddc0032962c194af2bb32208427947'
            }
        },
        mounted() {
            this.modalElement = document.getElementById('websiteFormModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)
            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)
            this.currentModal.show()
            this.website = this.model.website
        },
        beforeUnmount() {
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            noHandler(e) {
                // hide the modal
                // $('#websiteFormModal').modal('hide')
                this.currentModal.hide()
            },
            yesHandler(e) {

                if (this.website.subdomain === "" || (this.website.subdomain !== null && this.website.subdomain.trim() === "")) {
                    this.website.subdomain = null
                }

                let request = {
                    website: {
                        name: this.website.name,
                        custom_domain: this.website.custom_domain,
                        ga_tracking_id: this.website.ga_tracking_id,
                        metadata: this.website.metadata
                    }
                }

                if (this.website.id) {
                    this.update(request)
                } else {
                    this.create(request)
                    // hide the modal
                    this.noHandler()
                }

            },
            create(request) {
                this.service.create(request).then((response) => {
                    let newWebsite = response
                    let page = newWebsite.webpages[0]
                    this.$router.push({name: 'page-editor', params: {pageId: page.slug}})

                }).catch((message) => {
                    webase.utils.notification.error(message)
                })
            },
            update(request) {
                this.service.update(this.website.slug, request).then((response) => {
                    this.website = this.model.website = response

                    // call the parent's "yesEvent"
                    if (this.yesEvent) {
                        this.yesEvent(this.model.website)
                    }

                    if(!this.hasDnsZone) {
                        this.noHandler()
                    }

                }).catch((message) => {
                    webase.utils.notification.error(message)
                })
            },
            onDeleteClick() {
                this.noHandler()
                this.$emit('deleteClick')
            }
        }
    }
</script>
